import { apiClient } from '~services/api'
import { PointsHistoryResponse } from '~types/pointsHistory'
import { UserResponse, UserDiscountsListResponse, UserUpdateInput, PurchaseHistoryResponse } from '~types/user'

export const getServerUser = (): Promise<UserResponse> => {
  return apiClient.get<UserResponse, UserResponse>('/me')
}

export const getUserDiscountsList = (): Promise<UserDiscountsListResponse> => {
  return apiClient.get<UserDiscountsListResponse, UserDiscountsListResponse>(`/discount`)
}

export const getPurchaseHistory = (): Promise<PurchaseHistoryResponse> => {
  return apiClient.get<PurchaseHistoryResponse, PurchaseHistoryResponse>(`/discount/purchase-history`)
}

export const getRedeemedCoupons = (): Promise<PurchaseHistoryResponse> => {
  return apiClient.get<PurchaseHistoryResponse, PurchaseHistoryResponse>(`/discount/redeemed-coupons`)
}

export const getPointsHistory = (): Promise<PointsHistoryResponse> => {
  return apiClient.get<PointsHistoryResponse, PointsHistoryResponse>(`/history`)
}

export const updateUserRequest = (params: UserUpdateInput): Promise<UserResponse> => {
  return apiClient.post('/me', params)
}
